import {
  getNameDescriptionTableColumn,
  getTimeTableColumn,
  getCopyWithContentTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        field: 'enterprise_name',
        title: i18n.t('scope.text_318'),
        edit: false,
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.enterprise_name }</side-page-trigger>
          )
        },
      }),
      getCopyWithContentTableColumn({
        field: 'email',
        title: i18n.t('scope.text_431'),
        minWidth: 150,
      }),
      getCopyWithContentTableColumn({
        field: 'user_name',
        title: i18n.t('scope.text_322'),
        minWidth: 110,
      }),
      getCopyWithContentTableColumn({
        field: 'mobile',
        title: i18n.t('scope.text_494'),
        minWidth: 110,
      }),
      {
        field: 'memo',
        title: i18n.t('scope.text_327'),
        minWidth: 120,
        showOverflow: 'title',
      },
      getTimeTableColumn({ title: i18n.t('scope.text_498') }),
      {
        field: 'agent_level',
        title: i18n.t('scope.text_495'),
        minWidth: 80,
        formatter: ({ cellValue }) => {
          if (cellValue === 1) return i18n.t('scope.text_497')
          return i18n.t('scope.text_496')
        },
      },
    ]
  },
}
